import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarProdutoCaracteristicas(axios, parametros) {   
    parametros.operacao = 'buscarProdutoCaracteristicas';

    let retorno = {};
    
    await axios.santriGET('/rest/produto', parametros, 15, false)
      .then(response => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
      })
      .catch(error => {
        retorno = Biblioteca.retornoRequisicao('S', error, undefined);
      })
  
  
      return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/RProduto/RProdutoBuscarProdutoCaracteristicas.js